import script from "./MusicPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&setup=true&lang=js"

import "./MusicPlayer.vue?vue&type=style&index=0&id=d68ae768&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d68ae768"]])

export default __exports__